import type { OrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDateTime } from '@/shared/lib';
import { ContentCard, detailListStyles as styles } from '@/shared/ui';

interface OrderTimelineProps {
  readonly order: OrderDetail;
}

/** 진행 단계 — 주문 접수·결제·제작 착수(처리자 이름)·출고·배송 완료(처리자 이름 또는 자동 반영) 시각. */
export const OrderTimeline = ({ order }: OrderTimelineProps): ReactElement => (
  <ContentCard title="진행 단계">
    <dl className={styles.list}>
      <dt className={styles.term}>주문 접수</dt>
      <dd>{formatDateTime(order.createdAt)}</dd>
      <dt className={styles.term}>결제 완료</dt>
      <dd>
        {order.paidAt ? formatDateTime(order.paidAt) : <span className={styles.empty}>미결제</span>}
      </dd>
      <dt className={styles.term}>제작 착수</dt>
      <dd>
        {order.productionStartedAt ? (
          `${formatDateTime(order.productionStartedAt)} · 처리자 ${order.productionStartedByName ?? '—'}`
        ) : (
          <span className={styles.empty}>미착수</span>
        )}
      </dd>
      <dt className={styles.term}>출고</dt>
      <dd>
        {order.shippedAt ? (
          formatDateTime(order.shippedAt)
        ) : (
          <span className={styles.empty}>미출고</span>
        )}
      </dd>
      <dt className={styles.term}>배송 완료</dt>
      <dd>
        {order.deliveredOn ? (
          `${order.deliveredOn} · 처리자 ${order.deliveryCompletedByName ?? '자동 반영'}`
        ) : (
          <span className={styles.empty}>미완료</span>
        )}
      </dd>
    </dl>
  </ContentCard>
);
